/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Ils3Inputs */

const he_currency_ils3 = /** @type {(inputs: Currency_Ils3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ILS - Israeli Shekel`)
};

const en_currency_ils3 = /** @type {(inputs: Currency_Ils3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ILS - Israeli Shekel`)
};

/**
* | output |
* | --- |
* | "ILS - Israeli Shekel" |
*
* @param {Currency_Ils3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_ils3 = /** @type {((inputs?: Currency_Ils3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Ils3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_ils3(inputs)
	return en_currency_ils3(inputs)
});
export { currency_ils3 as "currency_ILS" }